import React, { useContext, useState } from 'react'

import { APIContext } from '../../../context/APIContext'
import { getEnvironment } from '../../../utils/appUtils'

import { Helmet } from 'react-helmet'

const Survey = () => {
  const apiContext = useContext(APIContext)
  const [feedbackUrl] = useState(apiContext[getEnvironment('SURVEY_URL')] || '')

  return (
    <Helmet>
      <script src={feedbackUrl} />
    </Helmet>
  )
}

export default Survey
